import { render, staticRenderFns } from "./DistanceSidebarMenu.vue?vue&type=template&id=05fa7a18&scoped=true&"
import script from "./DistanceSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./DistanceSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa7a18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05fa7a18')) {
      api.createRecord('05fa7a18', component.options)
    } else {
      api.reload('05fa7a18', component.options)
    }
    module.hot.accept("./DistanceSidebarMenu.vue?vue&type=template&id=05fa7a18&scoped=true&", function () {
      api.rerender('05fa7a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/SidebarComponents/DistanceSidebarMenu.vue"
export default component.exports